import { useApolloClient, useMutation } from '@apollo/client';
import { useState } from 'react';
import { GET_USER_TOKEN } from '../graphql';
import { setLocalStorageVariable } from '../apollo/helpers/local-storage';

const useGetUserToken = (tokenMinutes = 15) => {
  const [userId, setUserId] = useState('');
  const client = useApolloClient();
  const mutationResult = useMutation(GET_USER_TOKEN, {
    variables: {
      userId,
      tokenMinutes,
    },
    onCompleted: ({ getUserToken: { token } }) => {
      setUserId('');
      setLocalStorageVariable('token', token);
      client.cache.reset();
    },
  });
  return [userId, setUserId, mutationResult];
};

export default useGetUserToken;
